import {combineLatest, merge, partition} from 'rxjs';
import {filter, map, mergeAll} from 'rxjs/operators';
import {spotOrderUtil} from '@/helper/order-spot';
import {spots$} from '@/config';
import {incrementalOrders$} from '@/orders-spot/orders-spot';
import {convertConditionalOrder, convertNormalOrder} from '@/spot-utils/order-notification';

const incrementalOrder$ = incrementalOrders$.pipe(
  map(({open, closed}) => [].concat(open, closed)),
  mergeAll(),
  filter((order) => order.execStatus !== 'ReplaceToCanceled')
);

const [conditionalOrder$, normalOrder$] = partition(incrementalOrder$, (order) =>
  spotOrderUtil.isConditionalOrder(order)
);

export const conditionalOrderNotification$ = combineLatest([conditionalOrder$, spots$]).pipe(
  map(([order, spots]) => convertConditionalOrder(order, spots)),
  filter(Boolean)
);

export const normalOrderNotification$ = combineLatest([normalOrder$, spots$]).pipe(
  map(([order, spots]) => convertNormalOrder(order, spots)),
  filter(Boolean)
);

export const orderNotification$ = merge(conditionalOrderNotification$, normalOrderNotification$).pipe(
  filter((o) => !!o)
);
